import { render, staticRenderFns } from "./SendProductArtworkToCustomer.vue?vue&type=template&id=56594c66&scoped=true&"
import script from "./SendProductArtworkToCustomer.vue?vue&type=script&lang=js&"
export * from "./SendProductArtworkToCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56594c66",
  null
  
)

export default component.exports